module.exports = __webpack_public_path__ + "static/media/puerto-rico.0bc910cc.jpg";